import "./App.css";
import Select from "react-select";
import Chart from "./Chart";
import { useEffect, useState } from "react";
import countryArray from "./countries.json";
import axios from "axios";
import { color } from "highcharts";
import useData from "./useData";
import getUrl from "./getUrl";
import DropdownSelect from "./DropdownSelect";
import MultiSelect from "./MultiSelect";
import logo from "./Ember-logo.png";

const apiUrl =
  "https://ember-data-api-scg3n.ondigitalocean.app/ember/euromod_2022.json?_sort=rowid&country_name__in=Albania%2C+Germany&eu__in=EU27%2C+Non-EU&metric__exact=Generation&region__in=Southern%2C+Western&scenario__exact=System+Change&_shape=array";

const scenarioArray = [
  {
    scenario: "Stated Policy",
    info: "A pathway based on current stated policies by European countries.",
  },
  {
    scenario: "Technology Driven",
    info: "Power sector development determined by least-cost optimisation, within a carbon budget compatible with the Paris Agreement climate goals (1.5C), and consistent with a net-zero energy system by 2050.",
  },
  {
    scenario: "System Change",
    info: "A pathway aligned with the assumptions of CAN Europe’s Paris Agreement Compatible scenario (1.5C). Features the highest energy saving and electrification ambition, and is consistent with a net-zero energy sector by 2040.",
  },
  {
    scenario: "Alternative Hydrogen Supply",
    info: "The power system is only required to supply half as much hydrogen, with the shortfall supplied by alternative sources (dedicated off-grid electrolysis or imports from outside of Europe).",
  },
  {
    scenario: "Delayed Interconnections",
    info: "A combination of lack of preparedness, excessive bureaucracy, or social resistance delay and limit interconnection projects.",
  },
  {
    scenario: "High Fossil Fuel Prices",
    info: "Fossil fuel prices are increased between 2025 to 2050.",
  },
  {
    scenario: "Limited New Gas",
    info: "No new unabated gas capacity (either baseload or peaking) is deployed after 2025.",
  },
  {
    scenario: "Lower Demand Flexibility",
    info: "Governments and regulators fail to incentivise and enable the uptake of consumer technologies and behaviours required to deliver the assumed demand-side flexibility.",
  },
  {
    scenario: "No Gas and CCS",
    info: "Power plants equipped with carbon capture technology are not available for investment.",
  },
  {
    scenario: "Nuclear Plus",
    info: "Nuclear plant lifetimes are widely extended to 60 years (unless already stated to close by a specific date), and all planned new nuclear goes ahead (both conventional and Small Modular Reactor units).",
  },
  {
    scenario: "Resistance to RES",
    info: "Resistance to RES: Social acceptance issues limit the land available, and hence the technical potential of onshore wind and utility-scale solar.",
  },
  {
    scenario: "System Change-B",
    info: "Additional utility-scale battery capacity is added to the system compared to the 'System Change' scenario.",
  },
  {
    scenario: "Technology Driven-B",
    info: "Additional utility-scale battery capacity is added to the system compared to the 'Technology Driven' scenario.",
  },
];

const metricOptions = ["Generation", "Installed Capacity"];

const countryOptions = countryArray.map((country) => country.country_name);
const scenarioOptions = scenarioArray.map((scenario) => scenario.scenario);

function App() {
  const [metric, setMetric] = useState(metricOptions[0]);
  const [scenario, setScenario] = useState(scenarioOptions[0]);
  const [country, setCountry] = useState("All");

  const chartData = useData(metric, scenario, country);

  const title = `${metric} in the ${scenario} scenario`;

  const subtitle = (metric) => {
    let label;

    if (metric === "Generation") {
      label = "Gigawatt hours";
    } else {
      label = "Gigawatt";
    }

    return label;
  };

  const getScenarioInfo = () => {
    const selectedScenario = scenarioArray.filter(
      (scenarioObject) => scenarioObject.scenario === scenario
    );

    return selectedScenario[0].info;
  };

  return (
    <div className="euromod-explorer-container">
      <div className="grid-container">
        <div className="chart-container">
          <Chart
            seriesArray={chartData}
            title={title}
            subtitle={subtitle(metric)}
          />
        </div>
        <div className="metric-controls-container">
          <DropdownSelect
            options={scenarioOptions}
            value={scenario}
            onChange={(value) => setScenario(value)}
            title={"Select scenario"}
          />
          <DropdownSelect
            options={metricOptions}
            value={metric}
            onChange={(value) => setMetric(value)}
            title={"Select metric"}
          />
          <DropdownSelect
            options={countryOptions}
            value={country}
            onChange={(value) => setCountry(value)}
            title={"Select country"}
          />
        </div>
        <div className="scenario-info-container">
          <div className="scenario-info">
            <div className="scenario-info--title">{scenario} scenario</div>
            <div className="scenario-info--content">{getScenarioInfo()}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
